import React from "react";
import {Tooltip} from "@mantine/core";
import {IconHourglass, IconKey, IconLock} from "@tabler/icons-react";
import {useTranslation} from "react-i18next";
import {MemberStatusEnum} from "../domain/MemberModel/constants/MemberStatusEnum";

interface MemberStatusIconProps {
    status: MemberStatusEnum | undefined;
}

export function MemberStatusIcon({status}: MemberStatusIconProps): React.ReactNode {
    const {t} = useTranslation();


    if (status === null) {
        return null;
    }

    const renderIcon = (icon: React.ReactNode, label: string) => (
        <Tooltip label={label}>
            <div style={{cursor: 'help'}}>{icon}</div>
        </Tooltip>
    );

    switch (status as MemberStatusEnum) {
        case MemberStatusEnum.DISABLED:
            return renderIcon(<IconLock size={16} color="red"/>, t('Disabled'));

        case MemberStatusEnum.DISABLED_BAD_EMAIL:
            return renderIcon(<IconLock size={16} color="red"/>, t('Disabled bad email'));

        case MemberStatusEnum.DISABLED_HIMSELF:
            return renderIcon(<IconLock size={16} color="red"/>, t('Disabled himself'));

        case MemberStatusEnum.SPAM_ROBOT:
            return renderIcon(<IconLock size={16} color="red"/>, t('SPAM'));

        case MemberStatusEnum.AWAITING_ACTIVATION:
            return renderIcon(<IconHourglass size={16} color="orange"/>, t('Awaiting activation'));

        case MemberStatusEnum.DISABLED_BY_APPLICATION:
            return renderIcon(<IconKey size={16} color="blue"/>, t('Disabled by application'));

        default:
            return null;
    }
}